module.exports = __webpack_public_path__ + "img/memoji-black.4c93dc8d.png";